import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Birthdayqutes = () => {
    return (
        <Row className='p-4 d-flex align-items-center birthdayqutesrow my-4'>
            <Col className="p-4" lg={6} md={10} sm={12}>
                <h1 className="hometitle">Happy Birthday!</h1>
                <p>Need to send a gift that says it all? We all know someone who loves the color purple! If that’s you then the gorgeous combination of purple roses and pink lilies within our mixed bouquet, Royalty, is just what you are looking for! Whether you’re buying a bouquet for yourself or someone special, our website makes the process easy and simple!</p>
            </Col>
        </Row>
    );
};
export default Birthdayqutes;